import * as React from 'react';

export const COLOR_MODE_STORAGE_KEY = 'mgo-color-mode';

export const ColorModeContext = React.createContext({
  mode: 'light',
  setMode: () => {},
  toggleColorMode: () => {},
});
